export default __webpack_public_path__ + "static/media/memories-no-2.a12eae3e.mid";